import React from 'react';
import { Warning } from '@mui/icons-material';
import { Grid } from '@mui/material';
import { Colors, PrimaryButton, Text } from 'library';
import { useUserContext } from 'UserContext';
import PayMethod from './Components/PayMethod';
import BusinessPaymentMethod from './Components/business/BusinessPaymentMethod';
import { Address, IPayMethod } from 'models';
import { consoleLogInDev } from 'shared';
import { useStripe } from '@stripe/react-stripe-js';
import { verifyBankAccountMandate } from 'api/PaymentInformationApi';

export default function RenderPaymentMethod({
    payMethod,
    updatePayMethods,
    DefaultPayComponent,
    refreshPayMethods,
}: {
    payMethod: IPayMethod;
    DefaultPayComponent: JSX.Element;
    updatePayMethods: (a: Address[]) => void;
    refreshPayMethods: () => void;
}) {
    const { user } = useUserContext();
    const stripeHook = useStripe();

    const addresses = user?.address ?? [];

    function onVerifyClick() {
        const customer_id = user?.customer_id;
        verifyBankAccountMandate(stripeHook, payMethod.id, customer_id).then(refreshPayMethods).catch(consoleLogInDev);
    }

    return (
        <Grid
            style={{ backgroundColor: Colors.lightTurq, borderRadius: 18, padding: 10, marginBottom: 10 }}
            container
            direction="row"
            alignItems="center"
        >
            <Grid
                style={{
                    margin: '1em 0',
                }}
                item
                container
                xs={12}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <PayMethod payMethod={payMethod} />
                {payMethod.is_default ? <Text variant="body1">(Default)</Text> : DefaultPayComponent}
            </Grid>
            {user?.businesses_active?.length && addresses.length > 1 ? (
                <BusinessPaymentMethod payMethod={payMethod} updatePayMethods={updatePayMethods} />
            ) : null}
            {payMethod.needs_mandate && (
                <Grid
                    style={{
                        width: '100%',
                        padding: 20,
                        backgroundColor: Colors.lightRed,
                        borderRadius: 10,
                        border: `1px solid ${Colors.mediumRed}`,
                        marginBottom: 8,
                    }}
                >
                    <Grid style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                        <Warning style={{ color: Colors.mediumRed, fontSize: 20 }} />
                        <Text variant="body1" bold textStyle={{ color: Colors.mediumRed }}>
                            Action Required: Consent Needed
                        </Text>
                    </Grid>
                    <Text variant="body2" textStyle={{ marginBottom: 16 }}>
                        Action required by May 15: please re-authorize this payment method to avoid disruption. Without
                        this, payments will fail and shift posting will be disabled on your account.
                    </Text>
                    <PrimaryButton
                        buttonStyle={{ width: 'fit-content', backgroundColor: Colors.mediumRed }}
                        onClick={onVerifyClick}
                    >
                        Agree & Consent
                    </PrimaryButton>
                </Grid>
            )}
        </Grid>
    );
}
